<template>
    <div class="project-box">
        <Title :title="list.name" :url="`${domianURL}/${list.icoOne}`" />
        <div class="bg-petri">
            <div class="list">
                <div class="list-liangt" v-for="item in detil" :key="item.id">
                    <router-link
                        :to="{
                            path: 'details',
                            query: { type: item.id, id: $route.query.id },
                        }"
                    >
                        <img
                            src="@/assets/image/petrifaction/icon5.png"
                            class="icon"
                            alt=""
                        />
                        <span class="listle"> {{ item.title }}</span>
                    </router-link>
                </div>
            </div>
            <img
                src="@/assets/image/petrifaction/bg-2.png"
                class="petri"
                alt=""
            />
        </div>
        <Menu v-if="!isother" />
        <Othermenu v-else />
    </div>
</template>

<script>
import Menu from "@/components/menu.vue";
import Othermenu from "@/components/othermenu.vue";
import Title from "@/components/title.vue";
import { getAction } from "@/api/manage.js";
export default {
    created() {
        this.loadata();
    },
    updated() {
        if(this.$route.query.id == '1357260382288248834'){
            this.isother = true
        }
    },
    components: {
        Menu,
        Title,
        Othermenu
    },
    data() {
        return {
            detil: {},
            list: {},
            isother: false,
        };
    },
    watch: {
        $route(value) {
            if(value.query.id == '1357260382288248834'){
                this.isother = true
            }
        },
    },
    methods: {
        loadata() {
            getAction("/act/condensed/queryByType", {
                type: this.$route.query.id,
            }).then((res) => {
                if (res.success) {
                    this.detil = res.result;
                }
            });
            getAction("/sys/category/queryById", {
                id: this.$route.query.id,
            }).then((res) => {
                if (res.success) {
                    this.list = res.result;
                }
            });
        },
    },
};
</script>

<style lang="scss">
.project-box {
    .bg-petri {
        .petri {
            position: fixed;
            width: 100%;
            bottom: 0;
            left: 0;
            z-index: -1;
            opacity: .6;
        }
        .list {
            -webkit-animation: fade-in-top 0.8s cubic-bezier(0.39, 0.575, 0.565, 1)
                both;
            animation: fade-in-top 0.8s cubic-bezier(0.39, 0.575, 0.565, 1) both;
            margin-top: 30px;
            margin-left: 53px;
            .list-liangt {
                z-index: 99;
            }
            .icon {
                width: 2%;
            }
            .listle {
                font-size: 15px;
                font-weight: bold;
                line-height: 40px;
                letter-spacing: 0px;
                color: #333333;
            }
        }
    }
}
</style>
